export default __webpack_public_path__ + "2dd63a55668438762a7ed2ab4b13eb02.png";